<div class="service-unavailable-container">
  <img src="assets\images\clouds.svg" alt="Sad clouds" class="cloud-image" />
  <div class="user-message">
    {{ labels?.stellar?.serviceUnavailable?.header }}
  </div>
  <div class="access-down">
    {{ labels?.stellar?.serviceUnavailable?.accessDown }} <br />
    {{ labels?.stellar?.serviceUnavailable?.checkBackSoon }}
  </div>
  <div class="button-container">
    <button
      class="ok-button"
      color="primary"
      mat-raised-button
      (click)="closeWindow()"
    >
      {{ labels?.stellar?.ok }}
    </button>
  </div>
</div>
